import { Typography, Tooltip } from '@mui/material';
import LogoActiveSoft from '@/assets/icons/interrogation.svg';

export const TitlePages = ({ title, showInterrogation, showInterrogationText}: {title: string, showInterrogation?: boolean, showInterrogationText?: string}) => {
  return (
    <Typography gap={'7px'} display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{fontWeight: 400}} fontSize={'24px'} margin={'30px 0'} color={'#252525'}>
      {title}

      {
        showInterrogation &&
        <Tooltip title={showInterrogationText ?? ''} arrow>
          <img style={{ width: '25px' }} src={LogoActiveSoft} alt="Dúvida" />
        </Tooltip>
      }
    </Typography>
  );
};
